module.exports = __webpack_public_path__ + "static/sieben-stadte-der-liebe-01-550556639841d57f218b5d86a066098d.jpg";